/**
 * @description This helper wraps your click handler to ensure only fired when Enter or Spacebar is pressed.
 */
const onEnterAndSpace =
  (fn: (e: React.SyntheticEvent<HTMLElement>) => void) =>
  (event: React.KeyboardEvent<HTMLElement>) =>
    event.key === "Enter" || event.key === " " ? fn(event) : undefined;

export default onEnterAndSpace;
